import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Tag } from 'lucide-react';
import ProductCard from '@/components/ProductCard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CurrentDeals = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDeals();
  }, []);

  const fetchDeals = async () => {
    try {
      const response = await axios.get(`${API}/products`);
      const onSale = response.data.filter(p => p.sale_price && p.sale_price < p.price);
      setProducts(onSale);
    } catch (error) {
      console.error('Error fetching deals:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Loading deals...</p>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="min-h-screen py-16" data-testid="no-deals-page">
        <div className="container mx-auto px-4 md:px-8 lg:px-12 max-w-7xl">
          <div className="text-center">
            <div className="w-24 h-24 bg-secondary rounded-full flex items-center justify-center mx-auto mb-6">
              <Tag className="w-12 h-12 text-muted-foreground" />
            </div>
            <h1 className="heading-font text-5xl md:text-6xl font-bold mb-6" data-testid="no-deals-message">No Sales Currently!</h1>
            <p className="text-2xl text-muted-foreground">Check back next Friday!</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-16" data-testid="deals-page">
      <div className="container mx-auto px-4 md:px-8 lg:px-12 max-w-7xl">
        <div className="mb-12">
          <div className="inline-flex items-center gap-2 bg-accent/10 text-accent px-4 py-2 rounded-full mb-4">
            <Tag className="w-4 h-4" />
            <span className="text-sm font-semibold uppercase tracking-wider">Hot Deals</span>
          </div>
          <h1 className="heading-font text-5xl md:text-6xl font-bold mb-4" data-testid="deals-title">Current Deals</h1>
          <p className="text-lg text-muted-foreground">Save on these hand-picked plants while supplies last</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="deals-grid">
          {products.map((product) => (
            <ProductCard key={product._id} product={{ ...product, id: product._id }} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CurrentDeals;